import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchOrderList } from "../../redux/features/dashboard/dashboardAction";
import "./style.css";
import { CommonTable } from "../../modules/common/table/Table";
import { dashboardListColumns } from "../../modules/common/table/columns/_dashboardListColumns";
import SharedPagination from "../../modules/common/sharedPagination";
import { FiSearch } from "react-icons/fi";
import OrderDetailModal from "./OrderDetailModal";

const DashboardDetailsPage = () => {
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(true);
  const states = useSelector((state: any) => state.dashboardSlice);
  const limit = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");


  const dasboardList = states?.dashboard?.orders || [];
  const totalRecord = states?.totalRecord || 0;
  const totalPages = Math.ceil(totalRecord / limit);
  const otifRate = states?.dashboard?.otifRate


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const fetchInvoice = async () => {
      setLoading(true);
      try {
        await dispatch(FetchOrderList({
          page: currentPage,
          limit,
          search: searchQuery,
          // fromDate,
          // toDate,
        }));

      } catch (error) {
        console.error("Failed to fetch invoice:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInvoice();
  }, [currentPage, searchQuery]);

  return (
    <div className="order-status-container">
      <div className="flex flex-col items-center justify-center h-screen">
        <h3 className="text-2xl mb-4 page-title">Orders Dashboard</h3>
        <div className="otifRate">
          <div className="alert alert-warning d-flex align-items-center warningRate" role="alert">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            <div className="otifRatePara">
              Your OTIF rates need to be improved: ({otifRate})
            </div>
          </div>
          <div className="search-bar search-orders">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search order number..."
              className="form-control search-text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
        <div className='orderListTable'>
          {loading ? (
            <p className="loading-text">Loading Orders...</p>
          ) : dasboardList?.length > 0 ? (
            <CommonTable data={dasboardList} columns={dashboardListColumns} />
          ) : (
            <p className="no-orders">No Orders available yet.</p>
          )}
        </div>

        {totalRecord > limit && <SharedPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />}
      </div>
      {states?.openOrderListModal && (
        <OrderDetailModal />
      )}
    </div>
  );
};

export default DashboardDetailsPage;

